import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f1cabb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "day-off-select-container relative mb-3 pt-5 pb-3 px-4" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 align-self-start" }, "日時指定:", -1))
const _hoisted_4 = { class: "col-9" }
const _hoisted_5 = { class: "flex justify-content-between align-items-center" }
const _hoisted_6 = { class: "flex justify-content-between align-items-center mt-3" }
const _hoisted_7 = { class: "col-9 flex flex-column-reverse" }
const _hoisted_8 = ["hidden"]
const _hoisted_9 = { class: "circle-index" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "まで", -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "pb-2 m-0 orange" }

import { withDefaults, reactive, computed, ref, watch, nextTick } from "vue";
import { get, set } from "@vueuse/core";
import Calendar from "primevue/calendar";
import moment, { Moment } from "moment";
import { StaffTimeOff } from "@/clinic/typings";

type DayOffData = {
  timeOffs: StaffTimeOff[];
  day: string;
  disabledDates?: Date[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'day-off-select',
  props: {
    timeOffs: null,
    day: null,
    disabledDates: null
  },
  emits: ["onDeleteDate", "validateFn", "onDeleteTime", "onValidate", "onAddTime", "onChangeDate"],
  setup(__props: any, { emit: emits }) {

const props = __props as { timeOffs: StaffTimeOff[], day: string, disabledDates?: Date[] };



const timeOffData = ref(props.timeOffs);

const timeOffDataInit = computed(() => {
  let count = 1;
  const time_offs = get(timeOffData).filter((t: StaffTimeOff) => !t.destroy);
  time_offs.forEach(t => {
    t["position"] = count++;
  });
  return {
    timeOffs: time_offs,
    day: props.day,
  };
});
const validRanges = computed(() => {
  let isValid = true;
  let previousEnd: number | undefined = undefined;

  const sortedTimeOffs = get(timeOffData)
    .filter(t => !t.destroy)
    .sort((a, b) => new Date(a.from).getTime() - new Date(b.from).getTime());

  for (const t of sortedTimeOffs) {
    const from = new Date(t.from).getTime();
    const to = new Date(t.to).getTime();

    if (from >= to || (previousEnd != undefined && from < previousEnd)) {
      isValid = false;
      break;
    }

    previousEnd = to;
  }

  return isValid;
});
const shownTimeOffs = computed(() => get(timeOffData).filter(t => !t.destroy));

const form = reactive(timeOffDataInit.value);



const changeDate = (dateValue: any) => {
  const selectedDate = moment(dateValue).format("YYYY-MM-DD");
  const timeOffs = form.timeOffs
    .filter((time: StaffTimeOff) => !time.destroy)
    .map((time: any) => ({
      from: changeDayOfDate(selectedDate, moment(time.from).hour(), moment(time.from).minute()),
      to: changeDayOfDate(selectedDate, moment(time.to).hour(), moment(time.to).minute()),
      position: time.position,
    }));
  deleteDate();
  emits("onChangeDate", selectedDate, timeOffs);
};
const changeDayOfDate = (date: string, hour: number, minute: number) => moment(date).hour(hour).minute(minute).toDate();

const deleteDate = () => emits("onDeleteDate", props.day);
const addTime = () => {
  const position =
    shownTimeOffs.value.length == 0 ? 1 : shownTimeOffs.value[shownTimeOffs.value.length - 1].position + 1;
  const newTimeOff = {
    from: moment(props.day).set({ hour: 8, minute: 0 }).toDate(),
    to: moment(props.day).set({ hour: 17, minute: 0 }).toDate(),
    position: position,
  } as unknown as StaffTimeOff;

  get(timeOffData).push(newTimeOff);
  emits("onAddTime", props.day, newTimeOff);
};
const deleteTime = (t: StaffTimeOff) => {
  const index = get(timeOffData).indexOf(t);
  if (get(timeOffData)[index].id) {
    get(timeOffData)[index].destroy = true;
  } else {
    set(
      timeOffData,
      timeOffData.value.filter((_, i) => i != index)
    );
  }
  emits("onDeleteTime", props.day, t);

  nextTick(() => {
    let count = 1;
    timeOffData.value.forEach(t => {
      if (!t.destroy) {
        t.position = count++;
      }
    });
  });
};

watch(shownTimeOffs, newShownTimeOffs => {
  emits("onValidate", newShownTimeOffs.length > 0, validRanges.value);
});
watch(validRanges, newValidRanges => {
  emits("onValidate", shownTimeOffs.value.length > 0, newValidRanges);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Calendar), {
            modelValue: form.day,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.day) = $event)),
            class: "justify-content-end w-full",
            showIcon: "",
            dateFormat: "yy-mm-dd",
            disabledDates: props.disabledDates,
            selectOtherMonths: true,
            onDateSelect: _cache[1] || (_cache[1] = ($event: any) => (changeDate($event)))
          }, null, 8, ["modelValue", "disabledDates"]),
          _createElementVNode("i", {
            class: "pi pi-trash cursor-pointer orange delete-button ml-2",
            onClick: deleteDate
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", { class: "col-3 align-self-start flex align-items-center" }, [
        _createTextVNode(" 時間を選択 "),
        _createElementVNode("i", {
          class: "pi pi-plus-circle cursor-pointer orange ml-2",
          onClick: addTime
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("div", null, "休暇時間を選択してください。", 512), [
          [_vShow, _unref(timeOffDataInit).timeOffs.length === 0]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeOffDataInit).timeOffs, (time, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(`flex justify-content-between align-items-center w-full pb-3 time-${props.day}-${index}`),
            key: index,
            hidden: time.destroy
          }, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(time.position), 1),
            _createVNode(_unref(Calendar), {
              modelValue: time.from,
              "onUpdate:modelValue": ($event: any) => ((time.from) = $event),
              class: "time-select",
              showIcon: "",
              timeOnly: "",
              manualInput: false,
              icon: `pi pi-clock`,
              stepMinute: 5
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _hoisted_10,
            _createVNode(_unref(Calendar), {
              modelValue: time.to,
              "onUpdate:modelValue": ($event: any) => ((time.to) = $event),
              class: "time-select",
              showIcon: "",
              timeOnly: "",
              manualInput: false,
              icon: `pi pi-clock`,
              stepMinute: 5
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createElementVNode("i", {
              class: "pi pi-minus-circle cursor-pointer orange",
              onClick: ($event: any) => (deleteTime(time))
            }, null, 8, _hoisted_11)
          ], 10, _hoisted_8))
        }), 128)),
        _withDirectives(_createElementVNode("p", _hoisted_12, " 正しくない時間帯が入ってます。正しい時間帯を入力してください。 ", 512), [
          [_vShow, !_unref(validRanges)]
        ])
      ])
    ])
  ]))
}
}

})